module.exports = __webpack_public_path__ + "img/model_ug_59.15a96d4c.jpg";